import React from "../_snowpack/pkg/react.js";
import {render} from "../_snowpack/pkg/react-dom.js";
import {App} from "./app.js";
const ThemedApp = () => /* @__PURE__ */ React.createElement(App, null);
render(/* @__PURE__ */ React.createElement(ThemedApp, null), document.getElementById("root"));
